// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__lHEve","fakeInput":"Checkbox_fakeInput__rfdKJ","input":"Checkbox_input__H45In"};